import ReactMarkdown from 'react-markdown';
import { RootState, useAppSelector } from '../../store';
import AdminContainer from '../Utility/AdminContainer';

function Privacy() {
    const settings = useAppSelector((state: RootState) => state.settings);

    return (
        <div className="admin-container flex relative flex-col">
            <AdminContainer>
                <div className="box">
                    <ReactMarkdown className="text-layout-textcolor">{settings.dataProtectionText || ''}</ReactMarkdown>
                </div>
            </AdminContainer>
        </div>
    );
}

export default Privacy;
